// material-ui
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Modal,
    Checkbox,
    Grid,
    ToggleButtonGroup,
    ToggleButton,
    Button,
    Typography,
    TextField,
    Select,
    MenuItem
} from '@mui/material';
import { ManageAccounts, Cancel } from '@mui/icons-material';
import { styled, useTheme } from '@mui/material/styles';
import { useState, useEffect } from 'react';
import { deepPurple, grey } from '@mui/material/colors';
import useFetchData from 'hooks/useFetchData';
import { axiosInstance } from 'utils/axios';
import { useSelector } from 'react-redux';
import { selectCurrentToken } from 'features/auth/authSlice';
import { successAlert, errorAlert, warningAlert } from 'ui-component/Toasts';

import { useTranslation } from "react-i18next";
import { width } from '@mui/system';

const thirdPartyColumns = [
    { id: 'id', label: 'Count', minWidth: 30 },
    { id: 'name', label: 'Third Party Name', minWidth: 170 },
    { id: 'charges', label: 'Charges', minWidth: 170 },
];

const ThirdPartyTab = () => {
    const { t } = useTranslation();

    const token = useSelector(selectCurrentToken);

    const [bankAccountNumber, setBankAccountNumber] = useState({});

    const handleBankAccountNumber = (id, value) => {
        setBankAccountNumber(prev => ({ ...prev, [id]: value }));
    };

    const [programDetails, setProgramDetails] = useState([]);
    const fetchData = async () => {
        try {
            const res = await axiosInstance.get(`/ThirdParty`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setProgramDetails(res.data);
            }
        } catch (error) {

        }
    };

    useEffect(() => {
        if (programDetails.length > 0) {
            const newRateInputs = {};
            programDetails.forEach(detail => {
                newRateInputs[detail.id] = detail.bankAccountNumber;
            });

            console.log('newRateInputs 123', newRateInputs);
            setBankAccountNumber(newRateInputs);
        }
    }, [programDetails]);

    const [updateButtonDisabled, setUpdateButtonDisabled] = useState(false);
    const submitUpdateThirdPartyBankAccountNumber = async (id, newBankAccountNumber) => {
        setUpdateButtonDisabled(true);

        try {
            const res = await axiosInstance.put(
                '/ThirdParty/BankAccountNumber',
                {
                    id: id,
                    bankAccountNumber: newBankAccountNumber
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            if (res.status === 200) {
                successAlert('成功更新');
                fetchData();
            } else {
                errorAlert('发生错误');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setUpdateButtonDisabled(false);
        }
    };

    const activateThirdPartyBankAccountNumber = async (id) => {
        try {
            const res = await axiosInstance.put(
                '/ThirdParty/BankAccountNumber',
                {
                    id: id,
                    active: true
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            if (res.status === 200) {
                successAlert('成功更新');
                fetchData();
            } else {
                errorAlert('发生错误');
            }
        } catch (error) {
            console.log(error);
        } finally {
        }
    };

    const deactivateThirdPartyBankAccountNumber = async (id) => {
        try {
            const res = await axiosInstance.put(
                '/ThirdParty/BankAccountNumber',
                {
                    id: id,
                    active: false
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            if (res.status === 200) {
                successAlert('成功更新');
                fetchData();
            } else {
                errorAlert('发生错误');
            }
        } catch (error) {
            console.log(error);
        } finally {
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <>
            <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: '20px' }}>
                <TableContainer sx={{ height: '80vh' }}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                <TableCell key='details' style={{ width: 170 }}>{t("withdrawal.thirdPartyName")}</TableCell>
                                <TableCell key='walletAddress' style={{ width: 170 }}>{t("withdrawal.walletAddress")}</TableCell>
                                <TableCell key='button' style={{ width: 250 }}></TableCell>
                                <TableCell key='action' style={{ width: 250 }}></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {programDetails.map((row) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                                        <TableCell key='details' style={{fontSize: "12px"}}>
                                            {row.name}
                                        </TableCell>
                                        <TableCell key='walletAddress' style={{fontSize: "12px", width: '400px'}}>
                                            <Box sx={{ alignItems: 'center', display: 'flex', width: '100%' }}>
                                                <TextField 
                                                    id="outlined-basic" 
                                                    variant="outlined" 
                                                    value={bankAccountNumber[row.id] || ''}
                                                    onChange={(e) => handleBankAccountNumber(row.id, e.target.value)}
                                                    style={{fontSize: '12px', width: '100%'}}
                                                />
                                            </Box>
                                        </TableCell>
                                        <TableCell key='button' style={{fontSize: "12px"}}>
                                            <Box sx={{ alignItems: 'center', display: 'flex' }}>
                                                <Button
                                                    variant="contained"
                                                    sx={{
                                                        display: 'block',
                                                        mx: 'auto',
                                                        width: '150px',
                                                        backgroundColor: deepPurple[500]
                                                    }}
                                                    onClick={() => submitUpdateThirdPartyBankAccountNumber(row.id, bankAccountNumber[row.id])}
                                                    disabled={updateButtonDisabled}
                                                >
                                                    {t("masterData.update")}
                                                </Button>
                                            </Box>
                                        </TableCell>
                                        <TableCell key='action' style={{fontSize: "12px"}}>
                                            {
                                                row.active == false ?
                                                <>
                                                    <Button
                                                        onClick={() => activateThirdPartyBankAccountNumber(row.id)}
                                                        variant="contained"
                                                        style={{
                                                            border: 'none',
                                                            backgroundColor: 'green',
                                                            width: 'fit-content',
                                                            height: 'fit-content',
                                                            color: 'white',
                                                            padding: '6px 8px',
                                                            fontSize: '12px'
                                                        }}
                                                    >
                                                        {t("customer.activate")}
                                                    </Button>
                                                </> : 
                                                <>
                                                    <Button
                                                        onClick={() => deactivateThirdPartyBankAccountNumber(row.id)}
                                                        variant="contained"
                                                        style={{
                                                            border: 'none',
                                                            backgroundColor: 'red',
                                                            width: 'fit-content',
                                                            height: 'fit-content',
                                                            color: 'white',
                                                            padding: '6px 8px',
                                                            fontSize: '12px'
                                                        }}
                                                    >
                                                        {t("customer.deactivate")}
                                                    </Button>
                                                </>
                                            }
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </>
    );
};

export default ThirdPartyTab;